// const svg = `
//     <svg width="35" height="41" viewBox="0 0 35 41" fill="none" xmlns="http://www.w3.org/2000/svg">
//         <path d="M33.8984 1.23047L33.5088 2.20117L29.7061 11.6816L33.5088 21.1631L33.8984 22.1338H6.19922V39.6738H0.876953V1.23047H33.8984Z" fill="#A1A1A0" stroke="white" stroke-width="1.41411"/>
//     </svg>
// `

const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="203" height="231" viewBox="0 0 203 231" fill="none">
        <path d="M194.758 5.2002L192.016 12.0576L170.627 65.5273L192.016 118.999L194.758 125.855H37.4556V225.445H5.32471V5.2002H194.758Z" fill="#2D2926" stroke="white" stroke-width="10"/>
    </svg>
`

export const startPointFlagIcon = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`
